import { makeStyles } from '@material-ui/styles'
import tinycolor from "tinycolor2";

export default makeStyles(theme => ({
    contentDiv: {
      width: "100%"
    },
    notificationCallButton: {
      color: "white",
      marginBottom: theme.spacing(1),
      textTransform: "none"
    },
    notificationItem: {
      marginTop: theme.spacing(2)
    },
    notificationCloseButton: {
      position: "absolute",
      right: theme.spacing(2)
    },
    toastsContainer: {
      width: "auto",
      marginTop: theme.spacing(6),
      right: 0
    },
    progress: {
      visibility: "hidden"
    },
    notification: {
      display: "flex",
      alignItems: "center",
      background: "transparent",
      boxShadow: "none",
      overflow: "visible"
    },
    searchIcon: {
      color: "rgba(0, 0, 0, 0.23)"
    },

    notificationComponent: {
      paddingRight: theme.spacing(4),
    },

    savebuttonText: {
      color: 'black',
      "&:hover, &:focus": {
        backgroundColor: theme.lightgrey,
      }
    },

    saveEditAssetButtonBottom: {
      marginRight: "45px",
      padding: "6px 16px"
    },

    editAsset: {
      /*display: 'inline-flex',*/
      alignItems: 'center'
    },


    report: {
      fontSize: '1.285rem',
      display: 'inline-flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
      "& > svg": {
        fontSize: '1.285rem',
      },
      "& > a": {
        color: theme.palette.primary.main
      }
    },
    reportLinks: {
      display: 'flex',
      flexDirection: 'column',
      gap: '4px'
    }

}))
